module.exports = __webpack_public_path__ + "static/media/14.871021f0.jpg";